import React from "react";
import { Input, Form, Select, Button, message, Col, Row } from "antd";
import { graphql, compose } from "react-apollo";
import { FormattedMessage, injectIntl } from "react-intl";
import Portlet from "../../utils/portlet";
import Phone from "../../utils/intlPhone";
import { isValidNumber } from "libphonenumber-js";

import { COUNTRIES, USER_PROFILE } from "./gql/query";
import UPDATE_PROFILE, { UPDATE_PASSWORD } from "./gql/mutation";
import "./profile.css";

const FormItem = Form.Item;
const Option = Select.Option;

class FProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleInternalError = err => {
    const { formatMessage } = this.props.intl;
    message.error(
      formatMessage({
        id: "general.network-error",
        defaultMessage: "Network error, try again later"
      })
    );
  };

  handleSuccess = err => {
    const { locale } = this.props.intl;
    let error =
      locale === "ru-RU"
        ? "Профиль успешно обновлен"
        : "Profile has been updated";
    if (error) {
      return message.success(error);
    }
  };

  handleSubmitAccount = e => {
    e.preventDefault();
    this.props.form.validateFields(
      [
        "companyName",
        "firstName",
        "lastName",
        "position",
        "phone",
        "site",
        "country",
        "industry",
        "business"
      ],
      (err, values) => {
        if (!err) {
          const options = {
            variables: values,
            update: (proxy, {data: {data}}) => {
              proxy.writeQuery({
                query: USER_PROFILE,
                data: data.profile
              })
              console.log(" LOG ___ data ", data.profile, data.profile.user );
            }
          }
          this.props
            .mutate(options)
            .then(({ data }) => {
              message.success("Профиль обновлен");
            })
            .catch(this.handleInternalError);
        }
      }
    );
  };

  handleSubmitPassword = e => {
    e.preventDefault();
    this.props.form.validateFields(
      ["password", "currentPassword", "confirmPassword"],
      (err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          if (values.password !== values.confirmPassword) {
            message.error("Новый пароль и подтверждение не совпадают");
            return;
          }

          this.props
            .updatePassword({
              variables: values
            })
            .then(({ data }) => {
              if (!data.data.success) {
                message.error(data.data.error);
              } else {
                message.success("Пароль обновлен");
              }
            })
            .catch(error => {
              message.error("Произошла ошибка");
            });
        }
      }
    );
  };

  initialInput = ({
    id,
    defaultMessage,
    initialValue,
    readOnly = false,
    rules = [],
    type = "input",
    options = []
  }) => {
    return (
      <FormItem
        key={id}
        labelCol={{
          lg: type === "password" ? 12 : 8,
          md: 24,
          sm: type === "password" ? 12 : 8,
          xs: 24
        }}
        wrapperCol={{
          lg: type === "password" ? 12 : 16,
          md: 24,
          sm: type === "password" ? 12 : 16,
          xs: 24
        }}
        label={
          <FormattedMessage
            id={`profile.${id}`}
            defaultMessage={defaultMessage}
          />
        }
      >
        {type === "input"
          ? this.props.form.getFieldDecorator(id, {
              initialValue,
              rules
            })(<Input readOnly={readOnly} />)
          : type === "phone"
            ? this.props.form.getFieldDecorator(id, {
                initialValue,
                rules
              })(<Phone />)
            : type === "password"
              ? this.props.form.getFieldDecorator(id, {
                  rules: [{ required: true, message: initialValue }]
                })(<Input type={"password"} />)
              : this.props.form.getFieldDecorator(id, {
                  initialValue
                })(
                  <Select onChange={this.handleSelectChange}>
                    {options.map(
                      ({ id = "", defaultMessage, key, full_name }, i) => (
                        <Option value={id || key} key={i}>
                          {full_name ? (
                            full_name
                          ) : (
                            <FormattedMessage
                              id={`profile.select.${id}`}
                              defaultMessage={defaultMessage}
                            />
                          )}
                        </Option>
                      )
                    )}
                  </Select>
                )}
      </FormItem>
    );
  };

  render() {
    const { formatMessage } = this.props.intl;
    let profile = {};
    let countries = [];
    let firstName = "";
    let lastName = "";
    let companyName = "";

    if (this.props.data.loading || this.props.countries.loading) {
      return <div className="loading" />;
    } else {
      countries = this.props.countries.countries;
      profile = this.props.data.data;
      if (profile && profile.user) {
        lastName = profile.user.lastName;
        firstName = profile.user.firstName;
      }
      if (profile) {
        companyName = profile.companyName;
      }
    }
    const pwdInputMap = [
      {
        id: "currentPassword",
        defaultMessage: "Current password",
        type: "password",
        initialValue: formatMessage({
          id: "password.currentPassword",
          defaultMessage: "Enter your current password"
        })
      },
      {
        id: "password",
        defaultMessage: "New password",
        type: "password",
        initialValue: formatMessage({
          id: "password.newPassword",
          defaultMessage: "Enter your new password"
        })
      },
      {
        id: "confirmPassword",
        defaultMessage: "Confirm password",
        type: "password",
        initialValue: formatMessage({
          id: "password.confirmPassword",
          defaultMessage: "Confirm your new password"
        })
      }
    ];
    const accountInputMap = [
      {
        id: "companyName",
        defaultMessage: "Organization",
        initialValue: companyName,
        rules: [
          {
            required: true,
            min: 2,
            message: formatMessage({
              id: "profile.message.organization",
              defaultMessage: "Please fill in you Organization correctly"
            })
          }
        ]
      },
      {
        id: "firstName",
        defaultMessage: "First Name",
        initialValue: firstName,
        rules: [
          {
            required: true,
            min: 2,
            message: formatMessage({
              id: "profile.message.firstName",
              defaultMessage: "Please fill in you First name correctly"
            })
          }
        ]
      },
      {
        id: "lastName",
        defaultMessage: "Last Name",
        initialValue: lastName,
        rules: [
          {
            required: true,
            min: 2,
            message: formatMessage({
              id: "profile.message.lastName",
              defaultMessage: "Please fill in you Last name correctly"
            })
          }
        ]
      },
      {
        id: "position",
        defaultMessage: "Position",
        initialValue: profile.position,
        rules: [
          {
            required: true,
            min: 2,
            message: formatMessage({
              id: "profile.message.position",
              defaultMessage: "Please fill in you Position correctly"
            })
          }
        ]
      },
      {
        id: "phone",
        defaultMessage: "Phone",
        initialValue: profile.phone,
        type: "phone",
        rules: [
          {
            required: true,
            validator: (_, val, cb)=>{
              isValidNumber(val) 
                ? cb()
                : cb({
                    validateStatus: 'error',
                    errorMsg: 'Wrong phone number',
                  })
            },
            message: formatMessage({
              id: "profile.message.phone",
              defaultMessage: "Please fill in you Phone correctly"
            })
          }
        ]
      },
      {
        id: "site",
        defaultMessage: "Site",
        initialValue: profile.site,
        rules: [
          {
            required: true,
            message: formatMessage({
              id: "profile.message.site",
              defaultMessage: "Please fill in you Site correctly"
            }),
            pattern: /^(?:(?:https?|ftp):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/
          }
        ]
      },
      {
        id: "country",
        defaultMessage: "Country",
        initialValue: profile.country,
        type: "select",
        options: [
          ...countries.map(item => ({
            key: JSON.parse(item).key,
            full_name: JSON.parse(item).full_name
          }))
        ]
      },
      {
        id: "industry",
        defaultMessage: "Industry",
        initialValue: profile.industry,
        type: "select",
        options: [
          { id: "bank", defaultMessage: "Bank" },
          { id: "ecommerce", defaultMessage: "E-commerce" },
          { id: "mobileapp", defaultMessage: "Mobile app" },
          { id: "health", defaultMessage: "Health and wellness" },
          { id: "property", defaultMessage: "Property" },
          { id: "edu", defaultMessage: "Education" },
          { id: "gaming", defaultMessage: "Gaming" },
          { id: "trip", defaultMessage: "Traveling" },
          { id: "law", defaultMessage: "Law" }
        ]
      },
      {
        id: "business",
        defaultMessage: "Business",
        initialValue: profile.business,
        type: "select",
        options: [
          { id: "agency", defaultMessage: "Agency" },
          { id: "brokerage", defaultMessage: "Brokerage" },
          { id: "affilate", defaultMessage: "Affilate" },
          { id: "advertiser", defaultMessage: "Advertiser" },
          { id: "other", defaultMessage: "Other" }
        ]
      }
    ];
    return (
      <section className="profile-page">
        <h1>
          <FormattedMessage id="user-menu.profile" defaultMessage="Profile" />
        </h1>
        <Row className="profile-page__wrap" justify="space-between" type="flex">
          <Col className="profile-page__account" xs={24} sm={24} md={12}>
            <Portlet
              className="profile-page__portlet"
              header={
                <FormattedMessage
                  id="user-menu.account"
                  defaultMessage="Account information"
                />
              }
            >
              <Form onSubmit={this.handleSubmitAccount}>
                {accountInputMap.map(item => this.initialInput(item))}
                <FormItem wrapperCol={{ span: 8, offset: 8 }}>
                  <Button type="primary" htmlType="submit">
                    <FormattedMessage
                      id="settings.save"
                      defaultMessage="Save"
                      description="Save"
                    />
                  </Button>
                </FormItem>
              </Form>
            </Portlet>
          </Col>
          <Col className="profile-page__password" xs={24} sm={24} md={12}>
            <Portlet
              className="profile-page__portlet"
              header={
                <FormattedMessage
                  id="user-menu.password"
                  defaultMessage="Change password"
                />
              }
            >
              <Form onSubmit={this.handleSubmitPassword}>
                {pwdInputMap.map(item => this.initialInput(item))}
                <FormItem wrapperCol={{ span: 8, offset: 12 }}>
                  <Button type="primary" htmlType="submit">
                    <FormattedMessage
                      id="settings.save"
                      defaultMessage="Save"
                      description="Save"
                    />
                  </Button>
                </FormItem>
              </Form>
            </Portlet>
            <h4>
              <FormattedMessage
                id="user-menu.validation"
                defaultMessage="All fields are required"
              />
            </h4>
          </Col>
        </Row>
      </section>
    );
  }
}

const IProfile = Form.create()(injectIntl(FProfile));
const ProfileMutation = graphql(UPDATE_PROFILE, {
  options: {refetchQueries: [{query: USER_PROFILE}]}
})(IProfile);
const Profile = compose(
  graphql(UPDATE_PASSWORD, { name: "updatePassword" }),
  graphql(USER_PROFILE, { name: "data" }),
  graphql(COUNTRIES, { name: "countries" })
)(ProfileMutation);

export default Profile;



// WEBPACK FOOTER //
// ./src/components/dashboard/profile/index.js